import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { RequestList } from './RequestList';
import { PersonalInfoRequestList } from './PersonalInfoRequestList';
import { AddRequest, PersonalInfoRequest } from '@/types';

interface RequestTabsProps {
  addRequests: AddRequest[];
  infoRequests: PersonalInfoRequest[];
  isAdmin: boolean;
  onReviewAdd: (request: AddRequest) => void;
  onRejectAdd: (requestId: string) => void;
  onEditAdd: (request: AddRequest) => void;
  onReviewInfo: (request: PersonalInfoRequest) => void;
  onRejectInfo: (requestId: string) => void;
}

export function RequestTabs({
  addRequests,
  infoRequests,
  isAdmin,
  onReviewAdd,
  onRejectAdd,
  onReviewInfo,
  onRejectInfo,
  onEditAdd,
}: RequestTabsProps) {
  return (
    <Tabs defaultValue="add" dir="rtl" className="w-full">
      <TabsList className="w-full justify-start mb-6">
        <TabsTrigger value="add" className="flex-1">طلبات إضافة مولود</TabsTrigger>
        <TabsTrigger value="info" className="flex-1">طلبات إضافة من أنت</TabsTrigger>
      </TabsList>

      <TabsContent value="add" className="mt-0">
        <RequestList
          requests={addRequests}
          isAdmin={isAdmin}
          onReview={onReviewAdd}
          onReject={onRejectAdd}
          onEdit={onEditAdd}
        />
      </TabsContent>

      <TabsContent value="info" className="mt-0">
        <PersonalInfoRequestList
          requests={infoRequests}
          isAdmin={isAdmin}
          onReview={onReviewInfo}
          onReject={onRejectInfo}
        />
      </TabsContent>
    </Tabs>
  );
}